import React, { useState } from "react";
import WelcomeComponent from "./WelcomeComponent";

function WelcomeContainer() {

  return (
    <div className="container">
        <WelcomeComponent/>
    </div>
  );
}

export default WelcomeContainer;
